class LoaderController {
  constructor($rootScope, $scope) {
    this.name = "loader";
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.steps = [];
    this.loadingJobs = "Loading jobs...";
    this.applyingAttributes = "Applying attributes...";
    this.loadingJobDetails = "Loading job details...";
    this.loadingApplicants = "Loading applicants...";
    this.loadingPendingApplicants = "Loading pending applicants...";
    this.loadingAcceptedApplicants = "Loading accepted applicants...";
    this.loadingRoster = "Loading roster...";
    this.liveLoader = "Setting jobblers to map...";
    this.liveLoaderJob = "Locating job on map...";
    this.postJobLoader = "Posting job to board..";
    this.jobsBoardEntryLoader = "Welcome to Jobble: connecting you with flexible work...";
    this.savingShiftsLoader = "Saving shifts...";
    this.cloningLoader = "Cloning job...";
    this.jobbleTypesLoader = "Loading job types...";
    this.adLoader = "Loading uber application...";

    var _this = this;

    _this.setLoaderDialogListener = _this.$rootScope.$on("SetLoaderDialog", function (event, params) {
      _this.handleLoader(params);
      _this.params = params;
      if (params.type === 0) {
        _this.steps = [];
      }
    });

    _this.$scope.$on("$destroy", _this.setLoaderDialogListener);
  }

  handleLoader(status) {
    var _this = this;
    _this.total = status.total;
    switch (status.type) {
      case 0:
      //_this.steps = [];
      case 1:
        _this.steps.push(_this.loadingJobs);
        break;
      case 2:
        _this.steps.push(_this.applyingAttributes);
        break;
      case 3:
        _this.steps.push(_this.loadingJobDetails);
        break;
      case 4:
        _this.steps.push(_this.loadingApplicants);
        break;
      case 5:
        _this.steps.push(_this.loadingAcceptedApplicants);
        break;
      case 6:
        _this.steps.push(_this.loadingPendingApplicants);
        break;
      case 7:
        _this.steps.push(_this.loadingRoster);
        break;
      case 8:
        _this.steps.push(_this.liveLoader);
        break;
      case 9:
        _this.steps.push(_this.liveLoaderJob);
        break;
      case 10:
        _this.steps.push(_this.postJobLoader);
        break;
      case 11:
        _this.steps.push(_this.savingShiftsLoader);
        break;
      case 12:
        _this.steps.push(_this.cloningLoader);
        break;
      case 13:
        _this.steps.push(_this.jobbleTypesLoader);
        break;
      case 14:
        _this.steps.push(_this.adLoader);
        break;
      case 15:
        console.log("we are in case 15");
        _this.steps.push(_this.jobsBoardEntryLoader);
        break;
    }
  }
}
LoaderController.$inject = ["$rootScope", "$scope"];
export default LoaderController;



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.controller.js